export const ZhChsStarredMessagesStrings = {
  
  ERROR_MSG: {
    IN_INIT_CHATROOM: "聊天室正在初始化中, 请稍后再试"
  }
};
